export const cleanedQueryAccessories = (query: string = '', label: string) => {
  return query
    .split('%3A')
    .filter(
      (param, index, array) =>
        !(param.startsWith(label) && array[index + 1]) &&
        !(array[index - 1] && array[index - 1].startsWith(label))
    )
    .join('%3A');
};
